import React, { FC, ReactElement } from 'react'
import ButtonComponent, { ButtonComponentProps } from '../Button/ButtonComponent'

interface IChipButtonProps extends ButtonComponentProps {
  active?: boolean
  activeColor?: string
  activeIcon?: ReactElement
}

const ChipButton: FC<IChipButtonProps> = ({ active, activeColor, activeIcon, children, ...props }) => {
  const backgroundActiveColor = activeColor ? activeColor : '#CDE5FF'

  return (
    <ButtonComponent
      backgroundColor={active ? backgroundActiveColor : 'transparent'}
      borderRadius="8px"
      color="#42474E"
      border={active ? 'none' : '1px solid #42474E'}
      textTransform='initial'
      lineHeight='normal'
      fontWeight={500}
      padding="0.25rem 1.1rem"
      {...props}
    >
      <>
        {activeIcon && active && (
          <ButtonComponent.Icon>
            {activeIcon}
          </ButtonComponent.Icon>
        )}
        {children}
      </>
    </ButtonComponent>
  )
}

export default ChipButton
